export default __webpack_public_path__ + "09bf03c59f75350fba9765ea7b8f260b.png";